import React, { Fragment, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
// Redux
import { useDispatch, useSelector } from "react-redux";

// Icon
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import InfoIcon from "@mui/icons-material/Info";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";

import AddAdmin from "./dilogs/AddAdmin";
import ManageRole from "./dilogs/ManageRole";
import EditAdmin from "./dilogs/EditAdmin";
import DeleteAdmin from "./dilogs/DeleteAdmin";
import ChangesMade from "./dilogs/ChangesMade";
import ViewAdmin from "./dilogs/ViewAdmin";
import { getAdmins } from "../../../reduxToolkit/features/adminPanel/admin";
import { format } from "date-fns";
import { getRole } from "../../../reduxToolkit/features/adminPanel/role";
import { PF } from "../../../config";
import { getCreated, getExactTime } from "../../../hooks/getCreatedData";
import { colors, radii, shadows } from "../../../theme/designTokens";
import SearchFilterBar from "../../../components/adminPanel/shared/SearchFilterBar";
import SectionLabelChip from "../../../components/adminPanel/shared/SectionLabelChip";

export default function ManageAdmins({
  translate1,
  translate2,
  translate5,
  translate6,
}) {
  // Responsive
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));

  // Use State
  const [adminList, setAdminList] = useState([]);
  const [sortParam, setSortParam] = useState(0);
  const [sortAsc, setSortAsc] = useState(false);
  // Admin Edit
  const [editAdminDlg, setEditAdminDlg] = useState(false);
  const [editAdminBuffer, setEditAdminBuffer] = useState("");

  // Admin View
  const [viewAdminDlg, setViewAdminDlg] = useState(false);
  const [viewAdminBuffer, setViewAdminBuffer] = useState(false);

  //dialogs
  const [addAdminDlg, setAddAdminDlg] = useState(false);
  const [addRoleDlg, setAddRoleDlg] = useState(false);
  const [manageRoleDlg, setManageRoleDlg] = useState(false);
  // Delete ADmin
  const [deleteAdminDlg, setDeleteAdminDlg] = useState(false);
  const [deleteAdminBuffer, setDeleteAdminBuffer] = useState("");
  const [transferAdminBuffer, setTransferAdminBuffer] = useState("");
  // Changes Made
  const [changesMadeDlg, setChangesMadeDlg] = useState(false);
  const [changesMadeBuffer, setChangesMadeBuffer] = useState(0);

  // localData
  // const localData = JSON.parse(localStorage.getItem("adminLoginInfo"));

  // store
  let { admins, error } = useSelector((state) => state.admin);
  const { roles } = useSelector((state) => state.role);
  const { notifications } = useSelector((state) => state.notification);

  // Use Effect
  const dispatch = useDispatch();

  // get admin Model
  useEffect(() => {
    dispatch(getAdmins());
    dispatch(getRole());
  }, [dispatch]);

  // get Role Model
  useEffect(() => {
    const R = admins.map((x, i) => {
      return roles.find((r) => r._id === x.roleId);
    });
    let arr1 = [];
    admins.map((x, i) => arr1.push({ ...R[i], ...admins[i] }));
    if (notifications.length > 0) {
      const N = admins.map((x, i) => {
        const na = notifications.filter((n) => n.adminWhoCreatedId === x._id);
        const naJson = { changesMade: na.length };
        return naJson;
      });
      let arr2 = [];
      admins.map((x, i) => arr2.push({ ...N[i], ...arr1[i] }));
      arr2.sort((a, b) => a.priority - b.priority);

      setAdminList(arr2);
    } else setAdminList(arr1);
  }, [admins, notifications, roles]);

  // Functions
  const toggleSortDirection = () => {
    setSortAsc(!sortAsc);
    adminList.reverse();
  };

  const handleAdminSort = (e) => {
    if (e.target.value === 0) {
      adminList.sort((a, b) => a.priority - b.priority);
      setSortAsc(false);
    } else if (e.target.value === 1) {
      adminList.sort((a, b) => {
        const A = format(new Date(a.createdAt), "T");
        const B = format(new Date(b.createdAt), "T");
        return B - A;
      });
      setSortAsc(false);
    } else {
      adminList.sort((a, b) => b.changesMade - a.changesMade);
      setSortAsc(false);
    }
    setSortParam(e.target.value);
  };

  const handleAdminEdit = (id) => {
    const ae = adminList.find((o) => o._id === id);
    setEditAdminBuffer(ae);
    setEditAdminDlg(true);
  };

  const handleDeleteAdmin = (id) => {
    const ad = adminList.find((o) => o._id === id);
    setDeleteAdminBuffer(ad);
    setDeleteAdminDlg(true);
  };

  const handleChangesMade = (id) => {
    setChangesMadeBuffer(id);
    setChangesMadeDlg(true);
  };

  // Notification Dialog handler
  const handleChangesMadeClose = () => {
    setChangesMadeBuffer("");
    setChangesMadeDlg(false);
  };

  // View Admin FUnctions
  const handleViewAdmin = (id) => {
    setViewAdminBuffer(id);
    setViewAdminDlg(true);
  };

  // Fixed date
  const [showDate, setShowDate] = useState([]);

  const handleShowDate = (date) => {
    let arr = [...showDate];
    if (arr.includes(date)) {
      arr = arr.filter((a) => a !== date);
    } else {
      arr.push(date);
    }
    setShowDate(arr);
  };
  return (
    <>
      {!error && (
        <>
          <Grid
            container
            spacing={1}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                size="small"
                color="success"
                fullWidth
                startIcon={<PersonAddAlt1Icon />}
                onClick={() => setAddAdminDlg(true)}
              >
                {translate1("Add Admin")}
              </Button>
              <AddAdmin
                addAdminDlg={addAdminDlg}
                setAddAdminDlg={setAddAdminDlg}
                translate5={translate5}
                translate6={translate6}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="outlined"
                size="small"
                color="primary"
                fullWidth
                startIcon={<AdminPanelSettingsIcon />}
                onClick={() => setManageRoleDlg(true)}
              >
                {translate1("Manage Role")}
              </Button>
              <ManageRole
                addRoleDlg={addRoleDlg}
                setAddRoleDlg={setAddRoleDlg}
                manageRoleDlg={manageRoleDlg}
                setManageRoleDlg={setManageRoleDlg}
                translate6={translate6}
              />
            </Grid>
            <Grid item xs={12} sm sx={{ minWidth: 200 }}>
              <SearchFilterBar
                options={adminList}
                onChange={() => {}}
                optionsLimit={3}
                label={translate1("Search") + "..."}
                getOptionLabel={(option) => option.adminName}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                    {...props}
                  >
                    <Avatar
                      src={
                        option.adminPic.includes("http")
                          ? option.adminPic
                          : PF + "adminPanel/admins/" + option.adminPic
                      }
                      sx={{ width: 24, height: 24 }}
                    >
                      {option.adminName?.[0]}
                    </Avatar>
                    {option.adminName}
                  </Box>
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1.5} alignItems="center" sx={{ mt: 0.5 }}>
            <Grid item xs={10} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  {translate1("Sort")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={sortParam}
                  label={translate1("Sort")}
                  onChange={handleAdminSort}
                >
                  <MenuItem value={0}>{translate1("Role")} </MenuItem>
                  <MenuItem value={1}>{translate1("Creation")}</MenuItem>
                  <MenuItem value={2}>{translate1("Changes Made")}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} sm="auto">
              <IconButton size="small" onClick={toggleSortDirection}>
                {sortAsc ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
              </IconButton>
            </Grid>
            <Grid item xs={12} sm="auto" sx={{ ml: { sm: "auto" } }}>
              <SectionLabelChip
                label={translate1("Admins")}
                count={adminList.length}
              />
            </Grid>
          </Grid>
          {/* admins */}
          <Box
            sx={{
              maxHeight: { xs: "60vh", sm: "50vh" },
              overflowY: "auto",
              overflowX: "hidden",
              mt: 1,
            }}
          >
            {adminList.map((x, i) => (
              <Box
                key={i}
                sx={{
                  borderRadius: radii.lg,
                  boxShadow: shadows.card,
                  border: `1px solid ${colors.line}`,
                  bgcolor: colors.white,
                  my: 1,
                  p: 1.5,
                }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent={!smUp ? "center" : "space-between"}
                  alignItems="center"
                >
                  <Grid item xs={12} sm="auto">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, justifyContent: { xs: "center", sm: "flex-start" } }}>
                      <IconButton
                        size="small"
                        onClick={() => handleViewAdmin(x._id)}
                      >
                        <Avatar
                          alt={x.adminName}
                          src={
                            !x.adminPic.includes("http")
                              ? PF + "/adminPanel/admins/" + x.adminPic
                              : undefined
                          }
                          sx={{ width: 40, height: 40 }}
                        >
                          {x.adminName?.[0]}
                        </Avatar>
                      </IconButton>
                      <Box>
                        <Typography sx={{ fontWeight: 700, color: colors.ink }}>
                          {x.adminName}
                        </Typography>
                        <Chip
                          label={x.roleName}
                          size="small"
                          sx={{
                            bgcolor: x.color || colors.primaryLight,
                            fontWeight: 600,
                            mt: 0.25,
                          }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm="auto">
                    <Typography variant="body2" sx={{ color: colors.ink3, textAlign: { xs: "center", sm: "left" } }}>
                      {translate1("Created")}: {getCreated(x.createdAt)}
                      <Tooltip
                        arrow
                        placement="top"
                        title={getExactTime(x.createdAt)}
                      >
                        <IconButton
                          size="small"
                          onClick={() => handleShowDate(x.createdAt)}
                        >
                          <InfoIcon color="inherit" sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                      <br />
                      {showDate.includes(x.createdAt) &&
                        getExactTime(x.createdAt)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm="auto">
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                      <Badge
                        badgeContent={x.changesMade || 0}
                        color="error"
                        showZero
                        max={9999}
                      >
                        <Tooltip arrow title={translate1("Changes Made")}>
                          <IconButton
                            size="small"
                            onClick={() => handleChangesMade(x._id, i)}
                          >
                            <ManageHistoryIcon color="primary" />
                          </IconButton>
                        </Tooltip>
                      </Badge>
                      <IconButton
                        size="small"
                        onClick={() => handleAdminEdit(x._id)}
                      >
                        <ModeEditIcon color="warning" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteAdmin(x._id)}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ))}
            {/* Dialogs */}
            {/* View Admin Dialog */}
            <ViewAdmin
              viewProfileDlg={viewAdminDlg}
              setViewProfileDlg={setViewAdminDlg}
              adminId={viewAdminBuffer}
              adminList={adminList}
            />
            {/* Delete Admin Dialog */}
            <DeleteAdmin
              deleteAdminDlg={deleteAdminDlg}
              setDeleteAdminDlg={setDeleteAdminDlg}
              deleteAdminBuffer={deleteAdminBuffer}
              setDeleteAdminBuffer={setDeleteAdminBuffer}
              transferAdminBuffer={transferAdminBuffer}
              setTransferAdminBuffer={setTransferAdminBuffer}
              adminList={adminList}
            />
            {/* changes Made Dialog */}
            <Dialog
              open={changesMadeDlg}
              onClose={handleChangesMadeClose}
              fullWidth
              maxWidth={"sm"}
            >
              <DialogTitle>{translate1("Changes Made")}</DialogTitle>
              <DialogContent>
                <ChangesMade changesMadeBuffer={changesMadeBuffer} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleChangesMadeClose} color="error">
                  {translate2("Cancel")}
                </Button>
              </DialogActions>
            </Dialog>
            {/* Edit Admin */}
            <EditAdmin
              editAdminDlg={editAdminDlg}
              setEditAdminDlg={setEditAdminDlg}
              singleAdmin={editAdminBuffer}
            />
          </Box>
        </>
      )}
    </>
  );
}
